export enum ApprovalStatus {

  APPROVED,

  PENDING,

  NO_RESPONSE

}

export namespace ApprovalStatus {

  export function fromString(name: string): ApprovalStatus {
    return ApprovalStatus[name];
  }

  const MEANINGS = new Map<number, string>([
    [ApprovalStatus.APPROVED, 'Approved'],
    [ApprovalStatus.PENDING, 'Pending'],
    [ApprovalStatus.NO_RESPONSE, 'Approved - No Response'],
  ]);

  export function meaning(type: ApprovalStatus) {
    return MEANINGS.get(type);
  }

  export function values(): ApprovalStatus[] {
    return Array.from(MEANINGS.keys());
  }
}
